

export default function Contact() {
    
    return (
        <div className='contact'>
            <h1>Contact Me:</h1>
            <a href='mailto:lomick2090@gmail.com'><p>Email: Lomick2090@gmail.com</p></a>
            <a href='https://github.com/lomick2090'><p>Github</p></a>
            <a href='https://www.linkedin.com/in/jesse-stahl-b5b980276/'><p>LinkedIn</p></a>
            <a href='https://www.facebook.com/jesse.stahl/'><p>Facebook</p></a>
        </div>

    )
}